module.exports = __webpack_public_path__ + "img/sqgz.141497c0.png";